/**
  * Call push method of dataLayer to send data
  * @typedef {Function} dataLayer
  * @param {Object} data - Object with data to push
  * @param {string} dataLayerName - Name of the dataLayer to push
  * @default "dataLayer"
  * @return {void}
  */
export const dataLayer = (data, dataLayerName = 'dataLayer') => {
  if (window[dataLayerName]) return window[dataLayerName].push(data);
};

/**
  * Reset dataLayer variable.
  * Every variant also resets `parameters` and `extras`: GTM merges those objects
  * between pushes, so without a reset the parameters of a previous event would
  * persist into the next events that do not send them.
  * @typedef {Function} resetDataLayer
  * @param {string} variableName - Name of the variable to reset
  *   ('custom' | 'context' | 'ecommerce' | 'parameters')
  * @param {string} dataLayerName - Name of the dataLayer to push
  * @default "dataLayer"
  * @return {void}
  */
export const resetDataLayer = (variableName = 'custom', dataLayerName = 'dataLayer') => {
  const resetObject = {
    parameters: undefined,
    extras: undefined,
  };

  switch (variableName) {
  case 'context':
    resetObject['customer'] = undefined;
    resetObject['context'] = undefined;
    resetObject['screen'] = undefined;
    break;
  case 'custom':
    resetObject['custom'] = undefined;
    break;
  case 'ecommerce':
    resetObject['ecommerce'] = undefined;
    break;
  case 'parameters':
    // Only event parameters/extras: keeps page-level `custom` and `context` untouched
    break;
  }

  if (window[dataLayerName]) {
    return window[dataLayerName].push(resetObject);
  }
};
